// NotFound.js
import React from 'react';
import { Link } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css'; // Ensure Bootstrap styles are imported

const NotFound = () => {
    return (
        <div className="container mt-5">
            <div className="row">

                {/* Left Column for Image */}
                <div className="col-md-6 d-flex justify-content-center align-items-center">
                    <img 
                        src="https://res.cloudinary.com/dnbbm9vzi/image/upload/v1736001525/405_wyra8b.png" 
                        className="img-fluid" 
                        alt="404" 
                    />
                </div>

                {/* Right Column for Text and Button */}
                <div className="col-md-6 d-flex align-items-center">
                    <div className="content-wrapper px-5">
                        <div>
                            <h1 className="display-1 fw-bold">404</h1>
                            <h2 className="mb-4">Uh-oh… looks like this page pulled a disappearing act! 😏 </h2>
                            <p className="mb-4">
                                Head back home and get your dose of funny!
                            </p>
                            <Link to="/" className="btn btn-custom fw-bold btn-lg" style={{ backgroundColor: '#000', color: 'white' }}>
                                Take Me Home
                            </Link>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
};

export default NotFound;